import { render, staticRenderFns } from "./demo1.vue?vue&type=template&id=422da58d&"
import script from "./demo1.vue?vue&type=script&lang=js&"
export * from "./demo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "demo1.vue"
export default component.exports